import { render, staticRenderFns } from "./FirmwareTag.vue?vue&type=template&id=4158c982"
import script from "./FirmwareTag.vue?vue&type=script&lang=js"
export * from "./FirmwareTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports